import { Button, EpicIcons } from "@constellation-academy/epic-ui";
import { useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { createTextWithPagesElementButton_CreateTextWithPagesElementMutation } from "@relay/createTextWithPagesElementButton_CreateTextWithPagesElementMutation.graphql";
import { CREATE_TEXT_WITH_PAGES_ELEMENT_MUTATION } from "./create-text-with-pages-element-button.graphql";
import { CreateTextWithPagesElementButtonProps } from "./create-text-with-pages-element-button.types";
import { useDraftStatusUpdater } from "../use-draft-status-updater";

export const CreateTextWithPagesElementButton = ({
	eLearningContentNodeId,
}: CreateTextWithPagesElementButtonProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();
	const [createTextWithPagesElement, isCreatingTextWithPagesElement] =
		useMutation<createTextWithPagesElementButton_CreateTextWithPagesElementMutation>(
			CREATE_TEXT_WITH_PAGES_ELEMENT_MUTATION,
		);

	const handleCreateElement = () => {
		createTextWithPagesElement({
			variables: {
				input: {
					title: t("educationalOffer.newElement"),
					task: t("educationalOffer.newTaskText"),
					internalTitleForFirstPage: t("educationalOffer.newPageTitle"),
					textForFirstPage: t("educationalOffer.newText"),
					eLearningContentNodeId: eLearningContentNodeId,
				},
			},
			updater: setDraft,
		});
	};

	return (
		<Button
			disabled={isCreatingTextWithPagesElement}
			tooltip={t("educationalOffer.createTextWithPagesTooltip")}
			icon={EpicIcons.BOOK}
			onClick={handleCreateElement}
		/>
	);
};
